// React
import React from "react";
// Resources
import styles from "./PageHeader.module.scss";

export const PageHeader = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.page_header}>{children}</div>
);
